import type { ReactElement } from 'react';
import type { ValueOf } from 'type-fest';

export const NotifierType = {
  INFO: 'info',
  ERROR: 'error',
  SUCCESS: 'success',
  WARNING: 'warning',
} as const;

export type NotifierType = ValueOf<typeof NotifierType>;

export type NotifierProps = {
  message?: string;
  type?: NotifierType;
  icon?: ReactElement;
  children?: ReactElement;
  duration?: number;
  background?: string;
  onClose?: () => void;
  withCloseButton?: boolean;
};

export type NotifierContextType = {
  notify: (notifierProps: NotifierProps) => void;
};
